/* ผู้ใช้งาน + เมนูเปลี่ยนรหัสผ่าน/ออกจากระบบ (มุมขวาของแถบเมนูด้านบน) */
import { useEffect, useState } from "react";
import { Dropdown, Space, Typography } from "antd";
import { SettingOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { Authenticate } from "../../service/Authenticate.service";
import { useLoadingContext } from "../../store/context/loading-context";
import ModalResetPassword from "../modal/reset-password/ModalResetPassword";

const authService = Authenticate();

export default function HeaderUser() {
  const navigate = useNavigate();
  const { startLoading, stopLoading } = useLoadingContext();
  const [userInfo, setUserInfo] = useState(null);
  const [openResetPassword, setOpenResetPassword] = useState(false);

  useEffect(() => {
    setUserInfo(authService.getUserInfo());
  }, []);

  const onLogout = () => {
    startLoading();
    setTimeout(() => {
      authService.removeToken();
      stopLoading().then(() => navigate("/", { replace: true }));
    }, 500);
  };

  const items = [
    {
      key: "reset-password",
      label: (
        <Typography.Link onClick={() => setOpenResetPassword(true)}>
          <SettingOutlined style={{ marginRight: 6 }} />
          เปลี่ยนรหัสผ่าน
        </Typography.Link>
      ),
    },
    { type: "divider" },
    {
      key: "logout",
      label: (
        <Typography.Link onClick={onLogout} style={{ color: "#ff4d4f" }}>
          Log out
        </Typography.Link>
      ),
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Typography.Link onClick={(e) => e.preventDefault()} style={{ whiteSpace: "nowrap" }}>
          <Space size={6}>
            <UserOutlined style={{ color: "#8a5a1c" }} />
            <span style={{ fontSize: 13, fontWeight: 600, color: "#5e5f61" }}>
              {userInfo?.firstname} {userInfo?.lastname}
            </span>
            <span style={{ fontSize: 11, color: "#94a3b8" }}>
              {String(userInfo?.type || "").toUpperCase()}
            </span>
          </Space>
        </Typography.Link>
      </Dropdown>

      <ModalResetPassword
        open={openResetPassword}
        onClose={() => setOpenResetPassword(false)}
        userid={userInfo?.userid}
      />
    </>
  );
}
